import React, { useState, useContext } from 'react';
import { bool, array, string } from 'prop-types';
import classNames from 'classnames/bind';

import { StaticTextContext } from 'context/StaticTextContext';
import browserHistory from 'utils/browserHistory';

import SocialShareButton from 'components/SocialShareButton';
import BtnPrint from 'components/BtnPrint';
import Button from 'components/Button';

import IconArrowRight from 'media/icons/arrow-right-long.icon.svg';
import IconPdf from 'media/icons/pdf.icon.svg';

import styles from './TopButtonsGroup.module.scss';
const cx = classNames.bind(styles);

const TopButtonsGroup = ({ showBackButton, documents, pageTitle }) => {
  const [isShownSharing, setIsShownSharing] = useState(false);
  const { labels } = useContext(StaticTextContext);

  const historyBack = () => {
    browserHistory.go(-1);
  };

  return (
    <div className={cx('top-info', { 'show-sharing': isShownSharing })}>
      <div className={cx('column')}>
        {showBackButton && (
          <Button onClick={historyBack}>
            <span className={cx('btn-icon', 'icon-arrow')}>
              <IconArrowRight />
            </span>
            <span className={cx('btn-text')}>{labels.bulletinBackButton}</span>
          </Button>
        )}
      </div>

      <div className={cx('column')}>
        {documents && documents.length > 0 ? (
          <Button
            tag={'a'}
            href={documents[0]}
            target="_blank"
            type={'pdf'}
            className={cx('btn-download')}
            download
          >
            <span className={cx('btn-text')}>{labels.downloadButtonLabel}</span>
            <span className={cx('btn-icon', 'icon-pdf')}>
              <IconPdf />
            </span>
          </Button>
        ) : null}

        <BtnPrint />
        <SocialShareButton
          className={cx('social-share')}
          isShownSharing={isShownSharing}
          pageTitle={pageTitle}
          setIsShownSharing={setIsShownSharing}
        />
      </div>
    </div>
  );
};

TopButtonsGroup.propTypes = {
  pageTitle: string.isRequired,
  documents: array.isRequired,
  showBackButton: bool.isRequired,
};

export default TopButtonsGroup;



// WEBPACK FOOTER //
// ./src/components/TopButtonsGroup/TopButtonsGroup.js